import React from "react";
import CaseStudyPage from "./CaseStudyPage";

const CaseStudyOncology = () => (
  <CaseStudyPage
    category="Healthcare"
    client="US Oncology Practice (anonymized)"
    title="Prior Auth Automation Recovering $35K+ Monthly for a 6-Physician Oncology Practice"
    heroImage="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1600&q=80"
    challenge="Two dedicated prior auth coordinators were spending 65% of their time on manual status follow-ups — logging into payer portals, checking authorization status, chasing hold cases. New authorizations were being initiated but existing ones were aging without follow-up. The practice was seeing treatment delays and a measurable increase in denials tied directly to expired or lapsed authorizations."
    whatWeBuilt="A prior auth automation agent that monitors all outstanding authorizations, automatically checks payer portal status, flags aging cases before they expire, and generates escalation alerts for the clinical team. The system also identified a pattern of underpayments on infusion claims from two major commercial payers — triggering a recovery workflow that reconciled contracted rates against remittance data."
    results={[
      { value: "70%", label: "Reduction in prior auth follow-up time" },
      { value: "Significant", label: "Authorization lapse rate drop within 60 days" },
      { value: "$35K+", label: "Underpayments recovered in first quarter" },
      { value: "Reduced", label: "Treatment delay incidents as authorization turnaround improved" },
    ]}
    takeaway="The fastest path into an oncology practice is showing you already understand their ops before the first call ends. The audit found the underpayment pattern in 48 hours. The practice signed within a week."
  />
);

export default CaseStudyOncology;
